// @flow

"use strict";
import CookieUtil from "../../util/cookie-util";
import InnerToOuterDto from "../../model/dto/inner-to-outer-dto";
import OuterDIContainer from "./outer-di-container";
import Environment from "../common/environment";
import OuterWidget from "./outer-widget";
import Logger from "../common/logger";

/**
 * イベント監視クラス
 */
export default class Monitoring {
  constructor(diContainer: OuterDIContainer, environment: Environment, window: Window, doc: HTMLDocument) {
    this.diContainer = diContainer;
    this.registerResizeWidthEvent(window, doc);
    this.registerReceivePostMessageEvent(window, doc, environment);
    this.registerMeasureInviewEvent(window, doc);
  }

  /**
   * getInstance
   * @param diContainer
   * @param environment
   * @param window
   * @param doc
   * @returns {Monitoring}
   */
  static getInstance(diContainer: OuterDIContainer, environment: Environment, window: Window, doc: HTMLDocument): Monitoring {
    const uzouMonitoring = new Monitoring(diContainer, environment, window, doc);
    // singleton
    Monitoring.getInstance = function(): Monitoring{
      return uzouMonitoring;
    };

    return uzouMonitoring;
  }

  registerResizeWidthEvent(window: Window, doc: HTMLDocument){
    const _this = this;
    // リサイズイベントが何もなければイベント監視を行わない
    if (!_this.diContainer.handleResizeEvent) {
      return;
    }

    let resizeWaitTimer = false;  // resizeイベントコールバック遅延実行タイマー変数

    const resizeFunction: void = function () {
      // 遅延実行タイマーをクリアする
      if (resizeWaitTimer !== false) {
        clearTimeout(resizeWaitTimer);
      }
      // 遅延実行タイマーを再設定
      resizeWaitTimer = setTimeout(function () {
        window.Uzou.widgets.forEach(function (widget: OuterWidget) {
          // resizeWidth関数はwidgetから呼び出してください
          _this.diContainer.handleResizeEvent(widget, window, doc);
        });
      }, 200);
    };

    if (window.addEventListener) {
      window.addEventListener('resize', resizeFunction, false);
    } else if (window.attachEvent) {
      window.attachEvent('onresize', resizeFunction);
    }
  }

  /**
   * PostMessageイベント監視
   * @param window
   * @param doc
   * @param environment
   */
  registerReceivePostMessageEvent(window: Window, doc: HTMLDocument, environment: Environment){
    const receivePostMessageEventFunc = function (messageEvent: MessageEvent) {
      // originが(dev-|staging-| )speee-ad.akamaized.netのみ許可。ローカルの場合はすべて許可
      if (messageEvent.origin.match(environment.akamaiHost) || environment.isLocal() || environment.isTest()) {
        try{
          const dto = InnerToOuterDto.fromStringJson(messageEvent.data);  // フレーム内からのメッセージをJson文字列をDtoに変換
          window.Uzou.widgets.filter(function(widget: OuterWidget): void{
            return widget.id === dto.widgetId;
          }).forEach(function (widget: OuterWidget) {
            widget.receiveDto(dto); // Iframe内から受け取ったデータをwidgetにセット
            if (widget.user.uuid) {
              CookieUtil.saveUUID(widget.user.uuid, doc);
            }
            widget.resizeHeight(doc);  // iframe内のウィジェットの高さをiframeに設定する
          });
        } catch(e){
          window.Uzou.logger.error(e);
        }
      }
    };

    if (window.addEventListener) {
      window.addEventListener('message', receivePostMessageEventFunc, false);
    } else if (window.attachEvent) {
      window.attachEvent('onmessage', receivePostMessageEventFunc);
    }
  }

  /**
   * Inviewタイマー監視
   * @param window
   * @param doc
   */
  registerMeasureInviewEvent(window: Window, doc: HTMLDocument){
    const measureInviewFunc: void = function () {
      window.Uzou.widgets.forEach(function (widget: OuterWidget) {
        widget.measureInview(window, doc);
      });
    };

    // ブラウザタブが非アクティブになった時に一時的にタイマーを停止する IE10以上で対応
    let hidden;
    let visibilityChange;

    if (typeof document.hidden !== "undefined") { // Opera 12.10 や Firefox 18 以降でサポート
      hidden = "hidden";
      visibilityChange = "visibilitychange";
    } else if (typeof document.mozHidden !== "undefined") {
      hidden = "mozHidden";
      visibilityChange = "mozvisibilitychange";
    } else if (typeof document.msHidden !== "undefined") {
      hidden = "msHidden";
      visibilityChange = "msvisibilitychange";
    } else if (typeof document.webkitHidden !== "undefined") {
      hidden = "webkitHidden";
      visibilityChange = "webkitvisibilitychange";
    }

    let intervalId = false;

    // タブがアクティブの場合計測スタート
    if (!document[hidden]){
      intervalId = setInterval(measureInviewFunc, 1000);
    }

    if (typeof document.addEventListener !== "undefined" && typeof document[hidden] !== "undefined") {
      document.addEventListener(visibilityChange, function () {
        // タブが非アクティブになりタイマーが動いている場合はストップ
        if (document[hidden] && intervalId) {
          clearInterval(intervalId);
          intervalId = false;
          // タブが再度アクティブに戻った時にタイマーが動いてなければ再始動
        } else {
          if(!intervalId){
            intervalId = setInterval(measureInviewFunc, 1000);
          }
        }
      }, false);
    }
  }
}


// WEBPACK FOOTER //
// ./src/js/model/outer/monitoring.js